// Libs
import React from "react";

// Components
import ActiveFilter from "./activeFilters/ActiveFilter";

// Style
import { Container } from "./ActiveFiltersStyle";

// Utils
import { hyphenCaseToPascalCase } from "../../utils/string";

// i18n
import { useTranslation } from 'react-i18next';

import { allCategories } from '../../../newDropshipperApp/pages/search/staticCategories'

const ActiveFilters = ({ query, setQuery, clearAll, ...props }) => {
  const { t } = useTranslation();
  const getCategory = () => {
    const category = query['category']
    if (!category) return {};

    return allCategories().find( cat => cat.value === category )
  }
  const getSubCategory = () => {
    const category = getCategory();
    if (!category) return {};

    const subcategory = query['subcategory']
    if (!subcategory) return {};

    return getCategory().subcategories.find( scat => scat.name === subcategory )
  }
  const shippingTimeFormatter = value => {
    if (value === "1") {
      return t("AdvancedFilters.ShippingTime.One");
    } else if (value === "4") {
      return t("AdvancedFilters.ShippingTime.Four");
    } else if (value === "8") {
      return t("AdvancedFilters.ShippingTime.Eight");
    } else if (value === "15") {
      return t("AdvancedFilters.ShippingTime.Fifteen");
    } else {
      return t("AdvancedFilters.ShippingTime.Any");
    }
  };

  const shippingUnderFormatter = value => {
    if (value === "0") {
      return t("AdvancedFilters.ShippingCost.Free");
    } else if (value === "5") {
      return t("AdvancedFilters.ShippingCost.Five");
    } else if (value === "15") {
      return t("AdvancedFilters.ShippingCost.Fifteen");
    } else if (value === "25") {
      return t("AdvancedFilters.ShippingCost.TwentyFive");
    } else if (value === "any") {
      return undefined;
    }
  };

  const sortByFormatter = value => {
    if (value === "relevance") {
      return t("SortBy.DropDown.Item.Relevance");
    } else if (value === "low-to-high") {
      return t("SortBy.DropDown.Item.PriceLowToHigh");
    } else if (value === "high-to-low") {
      return t("SortBy.DropDown.Item.PriceHighToLow");
    } else if (value === "newest") {
      return t("SortBy.DropDown.Item.Newest");
    } else if (value === "shipping-time") {
      return t("SortBy.DropDown.Item.ShippingTime");
    } else {
      return value;
    }
  };

  const transpileFiltersKey = {
    keywords: { label: `${t("AdvancedFilters.transpileFiltersKey.Label.Keywords")}:`, value: "" },
    ships_from: { label: t("AdvancedFilters.transpileFiltersKey.Label.ShipsFrom"), value: "" },
    ships_to: { label: t("AdvancedFilters.transpileFiltersKey.Label.ShipsTo"), value: "" },
    supplier_name: { label: t("AdvancedFilters.transpileFiltersKey.Label.Supplier"), value: "" },
    category: { label: "", value: getCategory().label  },
    subcategory: { label: "", value: getSubCategory().label },
    sort_by: { 
      label: t("AdvancedFilters.transpileFiltersKey.Label.SortBy"),
      value: sortByFormatter(query.sort_by)
    },
    premium: { label: "", value: t("AdvancedFilters.transpileFiltersKey.Value.Premium") },
    supplier_verified: { label: "", value: t("AdvancedFilters.transpileFiltersKey.Value.TopSuppliers") },
    branded_invoicing: { label: "", value: t("AdvancedFilters.transpileFiltersKey.Value.PersonalizedInvoices") },
    best_selling: { label: "", value: t("AdvancedFilters.transpileFiltersKey.Value.BestSeller") },
    shipping_time: {
      label: t("AdvancedFilters.transpileFiltersKey.Label.Shipping"),
      value: shippingTimeFormatter(query.shipping_time)
    },
    shipping_under: {
      label: "",
      value: shippingUnderFormatter(query.shipping_under)
    },
    item_cost: {
      label: t("AdvancedFilters.transpileFiltersKey.Label.ItemCost"),
      value: query.item_cost ? (
        <span style={{ textTransform: "none" }}>
          { t("AdvancedFilters.transpileFiltersKey.Value.ItemCost.FromTo", { from: `$${query.item_cost[0]}`, to: `$${query.item_cost[1]}` }) }
        </span>
      ) : (
        ""
      )
    }
  };

  const activeQueryParams = () => {
    return Object.keys(query).filter(key => {
      // Remove main category when the subcategory is selected
      if (query.subcategory) {
        return query[key] && key !== "category";
      } else {
        return query[key] && query[key] !== "any";
      }
    });
  };

  return (
    <Container {...props}>
      {activeQueryParams().map(key => {
        return (
          <ActiveFilter
            key={key}
            onClick={() => setQuery({ [key]: undefined })}
            label={transpileFiltersKey[key].label}
          >
            {transpileFiltersKey[key].value
              ? transpileFiltersKey[key].value
              : hyphenCaseToPascalCase(query[key])}
          </ActiveFilter>
        );
      })}
      {activeQueryParams().length > 1 ? (
        <ActiveFilter
          onClick={() => clearAll()}
          style={{ backgroundColor: "white" }}
        >
          { t("AdvancedFilters.transpileFiltersKey.Label.ClearAll") }
        </ActiveFilter>
      ) : null}
    </Container>
  );
};

export default ActiveFilters;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/ActiveFilters.js